// import useStyles from "../styles";
// import { Grid } from "@mui/material";
// import Modal from "../../../components/Modal";
import { Icon } from "@iconify/react";
import Button from "../../../components/Button";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
// import ExaminationCard from "../../../components/ExaminationCard";
import { useNavigate, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { httprequest } from "../../../data/api";
import TabPanel from "@mui/lab/TabPanel";
import Tabs from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import Table from "../../../components/Table/Table";
import Badge from "../../../components/Badge";
// import Table from "../../../components/Table/Table";
// import { TableSearch } from "../../../components/Table/TableActions";
import PageTitle from "../../../components/PageTitle";
import { TableSearch } from "../../../components/Table/TableActions";
import { toast } from "react-toastify";
import Modal from "../../../components/Modal";
import PopModal from "../../../components/PopupModal/PopModal";
import useWindowSize from "../../../hooks/useWindow";
// import { Grade, ScoreLevel } from "../../../utils/DropDown";

// --| Dummy Data
const GET_ALL_SCHOOL_EXAMINATION = "/api/v1/exams";
const EXAM_CONFIG_ENDPOINT = "/api/v1/examination-configs";
const CLASSES_ENDPOINT = "/api/v1/class";

/** Row matches status filter; "empty" includes missing or explicit empty status. */
const matchesExamStatusFilter = (row, filterValue) => {
  if (!filterValue) {
    return true;
  }
  const f = String(filterValue).trim().toLowerCase();
  const s = String(row?.status ?? "").trim().toLowerCase();
  if (f === "empty") {
    return s === "" || s === "empty";
  }

  return s === f;
};

const Examination = () => {
  // const classes = useStyles();
  const navigate = useNavigate();
  const [value, setValue] = useState("1");
  const [searchResult, setSearchResult] = useState([]);
  // const [grademodal, setGradeModal] = useState();
  const [enrolmentresultbyclass, setEnrolmentResultByClass] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [allExamData, setAllExamData] = useState([]);
  const [allExamDataForClass, setAllExamDataForClass] = useState([]);
  const [convertModal, setConvertModal] = useState(false);
  const [currentSelected, setCurrentSelected] = useState({});
  const [preserveQuestionsInBank, setPreserveQuestionsInBank] = useState(false);
  const [classesData, setClassData] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const [filterStatus, setFilterStatus] = useState("");
  const [isConverting, setIsConverting] = useState(false);
  const [isPageFetching, setIsPageFetching] = useState(false);
  const [isForClassFetching, setIsForClassFetching] = useState([]);
  const preserveCheckboxStatus = String(currentSelected?.status ?? "").trim().toLowerCase();
  const shouldShowPreserveQuestionsCheckbox = preserveCheckboxStatus !== "" && preserveCheckboxStatus !== "empty";

  /**
 * Current window width and mobile status
 * @type {number} width - Current window width in pixels
 * @type {boolean} mobile - Whether window is mobile size (<600px)
 */
  const width = useWindowSize();
  const mobile = width < 600;

  /**
 * Fetches all school examination data
 */
  const getAllEnrollment = () => {
    setIsPageFetching(true);
    httprequest.get(GET_ALL_SCHOOL_EXAMINATION).then((res) => {
      setIsPageFetching(false);
      setFilterStatus("");
      setAllExamData(res?.data?.data);
      setSearchResult(res?.data?.data);
    }).catch((err) => {
      setIsPageFetching(false);
      toast.error(err?.response?.data);
    });
  };

  /**
 * Fetches enrolment exams for a specific class
 * @param {string} classId - The ID of the class to filter by
 */
  const getAllEnrollmentExamByClass = (classId) => {
    setIsForClassFetching(true);
    httprequest.get(`${GET_ALL_SCHOOL_EXAMINATION}?class_id=${classId}`).then((res) => {
      setIsForClassFetching(false);
      setFilterStatus("");
      setAllExamDataForClass(res?.data?.data);
      setEnrolmentResultByClass(res?.data?.data);
    }).catch((err) => {
      setIsForClassFetching(false);
      toast.error(err?.response?.data);
    });
  };

  /**
 * Handles tab change events and fetches class-specific data when needed
 * @param {Event} event - The tab change event
 * @param {string} newValue - The new tab value
 */
  const handleChange = (event, newValue) => {
    setValue(newValue);

    // Fetch data only if a specific class tab is selected
    if (newValue !== "1") {
      getAllEnrollmentExamByClass(newValue);
    }
  };

  /**
 * Fetches all physical classes
 */
  const getAllClasses = () => {
    httprequest.get(CLASSES_ENDPOINT).then((res) => {
      const physicalClasses = res?.data?.data?.filter((data) => data?.class_type === "physical");
      setClassData(physicalClasses);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  /**
 * Opens delete confirmation modal for an exam
 * @param {Object} row - The exam row data to potentially delete
 */
  const handleDeleteModal = (row) => {
    setCurrentSelected(row);
    setPreserveQuestionsInBank(false);
    setDeleteModal(!deleteModal);
  };

  /**
 * Opens convert confirmation modal for an exam
 * @param {Object} row - The exam row data to potentially convert
 */
  const handleConvertModal = (row) => {
    setCurrentSelected(row);
    setConvertModal(!convertModal);
  };

  /**
 * Closes the delete confirmation modal
 */
  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
    setPreserveQuestionsInBank(false);
  };

  /**
 * Closes the convert confirmation modal
 */
  const handleCloseConvertExam = () => {
    setConvertModal(false);
  };

  /**
 * Handles deletion of an exam
 */
  const handleDeleteAnExam = () => {
    setIsDeleting(true);
    httprequest.delete(`${EXAM_CONFIG_ENDPOINT}/${currentSelected?.id}`, {
      data: {
        preserve_questions_in_bank: !!preserveQuestionsInBank
      }
    }).then(() => {
      setIsDeleting(false);
      toast.success("Exam Deleted Succesfully");
      getAllEnrollment();
      handleCloseDeleteModal();
    }).catch((err) => {
      setIsDeleting(false);
      toast.error(err?.response?.data?.message);
    });
  };

  /**
 * Handles conversion of an exam
 */
  const handleConvertExam = () => {
    setIsConverting(true);
    httprequest.post(`${GET_ALL_SCHOOL_EXAMINATION}/${currentSelected?.school_exam_id}/convert`).then((res) => {
      setIsConverting(false);
      toast.success(res?.data?.message);
      getAllEnrollment();
      handleCloseConvertExam();
    }).catch((err) => {
      setIsConverting(false);
      toast.error(err?.response?.data?.message);
    });
  };

  /**
 * Effect hook that runs on component mount to fetch initial data
 */
  useEffect(() => {
    getAllEnrollment();
    getAllClasses();
    // getAllEnrollmentExamByClass();
  }, []);
  // const handleGradeModal = () => {
  //   setGradeModal(!grademodal);
  // };

  // const [searchResult, setSearchResult] = useState([]);

  /**
 * Columns configuration for the exams table
 * @type {Array<Object>}
 * @property {string} name - Column header name
 * @property {function} selector - Function to render cell content
 * @property {boolean} [center] - Whether to center-align content
 * @property {boolean} [sortable] - Whether column is sortable
 * @property {function} [cell] - Custom cell renderer function
 */
  const columns = [
    {
      name: "Subject",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Subject</p>}
          {row?.subject?.name || "--/--"}
        </>
      )
    },
    {
      name: "Classes",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Classes</p>}
          {row?.classes?.map((clss) => (
            <span className="class_div" key={clss?.id}>
              {clss?.name}
            </span>
          )) || "--/--"}
        </>
      )
    },
    {
      name: "Created By",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Created By</p>}
          {`${row?.created_by?.first_name || ""} ${row?.created_by?.last_name || ""}` || "--/--"}
        </>
      )
    },
    {
      name: "Duration (in mins)",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Duration (in mins)</p>}
          {row?.duration || "--/--"}
        </>
      )
    },
    {
      name: "Date Updated",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Date Updated</p>}
          {row?.updated_at ? row.updated_at.substring(0, 10) : "--/--"}
        </>
      )
    },
    {
      name: "Status",
      center: true,
      cell: (row) => <Badge status={row?.status} />
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <Link to={`/school-examination/examination-details/${row?.id}`}>
            <button className="table-action-icon">
              <Icon icon="fluent:eye-16-regular" />
            </button>
          </Link>
          <button
            className="table-action-icon"
            onClick={() => navigate(`/school-examination/examination-details/${row?.id}?editConfig`)}
          >
            <Icon icon="heroicons:pencil-square-solid" />
          </button>
          {row?.status && (
            <button
              onClick={() => handleConvertModal(row)}
              className="table-action-icon"
            >
              <Icon icon="ion:reload-circle-sharp" width="20" height="20" />
            </button>
          )}
          <button className="table-action-icon delete-icon" onClick={() => handleDeleteModal(row)}>
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }
  ];
  /**
 * Filters enrolment exams by class based on status
 * @param {Event} e - The filter change event
 */
  const handleFilterClassChange = (e) => {
    const { value } = e.target;
    setFilterStatus(value);

    const filteredByStatus = value
      ? enrolmentresultbyclass?.filter((data) => matchesExamStatusFilter(data, value))
      : enrolmentresultbyclass;

    setAllExamDataForClass(filteredByStatus);
  };

  // Handle Filter for All School Examination
  const handleFilterChange = (e) => {
    const { value } = e.target;
    setFilterStatus(value);

    const filteredByStatus = value
      ? allExamData?.filter((data) => matchesExamStatusFilter(data, value))
      : allExamData;
    setSearchResult(filteredByStatus);
  };

  /**
 * Filters all school examinations by status
 * @param {Event} e - The filter change event
 */
  const handleSearchAllEnrolmentExam = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");

    const filteredByStatus = filterStatus
      ? allExamData.filter((data) => matchesExamStatusFilter(data, filterStatus))
      : allExamData;
    // --| Filter data by partial match onchange in the search input box
    const result = filteredByStatus?.filter((data) => valArray?.every(
      (word) => data?.subject?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                data?.class?.name?.toLowerCase()
                  .includes(word.toLowerCase()) ||
                data?.created_by?.name?.toLowerCase()
                  .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  /**
 * Searches all enrolment exams by various fields
 * @param {Event} e - The search input event
 */
  const handleSearchAssignmentByClass = (e) => {
    const { value } = e.target;
    const valArray = value.split(" ");

    const filteredByStatus = filterStatus
      ? enrolmentresultbyclass.filter((data) => matchesExamStatusFilter(data, filterStatus))
      : enrolmentresultbyclass;

    // Filter by partial match in subject, class, and creator's name
    const result = filteredByStatus?.filter((data) => valArray?.every(
      (word) => data?.subject?.name?.toLowerCase().includes(word.toLowerCase()) ||
                data?.classes?.name?.toLowerCase().includes(word.toLowerCase()) ||
                data?.created_by?.name?.toLowerCase().includes(word.toLowerCase())
    ));

    setAllExamDataForClass(result);
  };

  return (
    <>
      <PageTitle
        title="Examination"
        subtitle="View all the examination"
        button={
          <div className="flex gap-10">
            <PopModal videoUrl="https://youtu.be/4c8P3Umbytw" title="Examination" />
            <Button onClick={() => navigate("/school-examination/create-examination")} variant="primary" buttonSize="fluid" color="btndefault" buttonName="Create Examination" />
          </div>
        }
      />
      <div className="page-content">
        <TabContext value={value}>
          {allExamData?.length > 0 && (
            <div className="tablist-container padding-left-16">
              <Tabs
                className="overide-tablist"
                onChange={handleChange}
                aria-label=""
              >
                <Tab label="All Examination" value="1" />
                {classesData?.map((data, i) => {
                  return (
                    <Tab key={i} value={data?.id} label={data?.class_name} />
                  );
                })}
              </Tabs>
            </div>
          )}

          <TabPanel value="1" className="tabpanel-overide">
            <Table data={searchResult} columns={columns} subHeader={true} pagination subHeaderComponent={
              (allExamData?.length > 0 || filterStatus) && (
                <div className="action_div">
                  <TableSearch placeholder="Search here..." searchTableFunc={handleSearchAllEnrolmentExam} />
                  <div className="text-center gap-10 cursor-pointer">
                    {isPageFetching ? <Icon icon="svg-spinners:270-ring-with-bg" width="20" height="20" style={{ color: "#858585" }} />
                      : <Icon onClick={getAllEnrollment} icon="hugeicons:reload" width="20" height="20" style={{ color: "#858585" }} />}
                    <div>
                      <SelectGroup
                        children={
                          <select name="type" value={filterStatus} onChange={handleFilterChange}>
                            <option value="">-- Sort By--</option>
                            <option value="published">Published</option>
                            <option value="draft">Draft</option>
                            <option value="empty">Empty</option>
                            <option value="withdrawn">Withdrawn</option>
                          </select>
                        }
                      />
                    </div>
                  </div>
                </div>
              )
            }
            />
          </TabPanel>
          {classesData?.map((data, i) => {
            return (
              <TabPanel className="tabpanel-overide" key={i} value={data?.id}>
                <Table
                  data={allExamDataForClass}
                  columns={columns}
                  subHeader={true}
                  pagination
                  subHeaderComponent={
                    (enrolmentresultbyclass?.length > 0 || filterStatus) && (
                      <div className="action_div">
                        <TableSearch placeholder="Search here..." searchTableFunc={handleSearchAssignmentByClass} />
                        <div className="text-center gap-10 cursor-pointer">
                          {isForClassFetching ? <Icon icon="svg-spinners:270-ring-with-bg" width="20" height="20" style={{ color: "#858585" }} />
                            : <Icon onClick={() => getAllEnrollmentExamByClass(data?.id)} icon="hugeicons:reload" width="20" height="20" style={{ color: "#858585" }} />}
                          <div>
                            <SelectGroup
                              children={
                                <select name="type" value={filterStatus} onChange={handleFilterClassChange}>
                                  <option value="">-- Sort By--</option>
                                  <option value="published">Published</option>
                                  <option value="draft">Draft</option>
                                  <option value="empty">Empty</option>
                                  <option value="withdrawn">Withdrawn</option>
                                </select>
                              }
                            />
                          </div>
                        </div>
                      </div>
                    )

                  }
                />
              </TabPanel>
            );
          })}
        </TabContext>
      </div>
      <Modal
        title="Delete School Examination"
        subtitle={
          <div>Are you sure you want to delete
            <span className="modal-name-highlight">{" "}
              {currentSelected?.subject?.name ?? "this subject"} for{" "}
              {currentSelected?.classes?.map((clss, index) => (
                <span className="" key={clss?.id}>
                  {clss?.name}
                  {index < currentSelected.classes.length - 1 ? ", " : ""}
                </span>
              )) || " these classes"}.
            </span>{" "}
             Implication is that this Examination will be deleted completely
          </div>}
        modalContent={
          <>
            {shouldShowPreserveQuestionsCheckbox && (
              <div style={{ marginTop: 8 }}>
                <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    checked={preserveQuestionsInBank}
                    onChange={(e) => setPreserveQuestionsInBank(e.target.checked)}
                  />
                  Preserve questions on this Examination and add them to bank.
                </label>
              </div>
            )}
          </>
        }
        modalFooter={
          <>
            <Button variant="danger" buttonName="Delete Examination" buttonSize="full" color="btndefault" onClick={handleDeleteAnExam} isLoading={isDeleting} />
          </>
        }
        isopen={deleteModal}
        closeModal={handleCloseDeleteModal}
      />
      {/* Convert MOdal */}
      <Modal
        title="Convert Examination to Enrolment Examination"
        subtitle={
          <div>
      Are you sure you want to convert
            <span className="modal-name-highlight">{" "}
              {currentSelected?.subject?.name ?? "this subject"} for{" "}
              {currentSelected?.classes?.map((clss, index) => (
                <span className="" key={clss?.id}>
                  {clss?.name}
                  {index < currentSelected.classes.length - 1 ? ", " : ""}
                </span>
              )) || " these classes"}
            </span>{" "}
      to an Enrolment Examination?
          </div>
        }
        modalContent={<></>}
        modalFooter={
          <>
            <Button
              variant="primary"
              buttonName="Convert Examination"
              buttonSize="full"
              color="btndefault"
              onClick={handleConvertExam}
              isLoading={isConverting}
            />
          </>
        }
        isopen={convertModal}
        closeModal={handleCloseConvertExam}
      />

    </>
  );
};

export default Examination;
